var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMacFill = function SvgMacFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.9 8.7v.9l.9.45v.45H4.2l-.002-.448L5.1 9.6v-.9H1.946a.45.45 0 0 1-.446-.453V2.403c0-.25.205-.453.446-.453h8.108a.45.45 0 0 1 .446.453v5.844c0 .25-.205.453-.446.453zM2.4 6.9v.9h7.2v-.9z"
  })));
};
export default SvgMacFill;